import { PayloadAction } from '@reduxjs/toolkit';
import { call, select, takeEvery } from 'typed-redux-saga';

import { selectIsMeetingRoomIntegration } from '../../../shared/features/config/selectors';
import { parentFrameCommunicator } from '../../../shared/features/parent-frame-communicator';
import { ConferenceStatus } from '../constants';
import { setConferenceStatus } from '../features/conference/slice';
import { OutgoingEvents } from './types';

export function* handleConferenceStatus(): Generator {
    const isMeetingRoomIntegration = yield* select(selectIsMeetingRoomIntegration);

    if (!isMeetingRoomIntegration) {
        return;
    }

    yield* takeEvery(setConferenceStatus, function* ({ payload: status }: PayloadAction<ConferenceStatus>) {
        yield* call(parentFrameCommunicator.sendMessage, 'meeting-room', {
            event: OutgoingEvents.CONFERENCE_STATUS,
            payload: { status },
        });
    });
}
